export default function auth({ next, store }) {
  store.dispatch('register/checkCookies');
  if (!store.getters.isAuth) {
    return next({
      name: 'login',
    });
  }
  return next();
}
